<app-base-side-panel-modal [allowFooter]="false">
  <ng-template #header>
    <div class="flex justify-start items-center gap-3">
      <svg-icon class="w-8 h-8 svg-dark" [src]="'edit'"></svg-icon>
      <div class="text-navy-90">
        {{ buildTranslationKey('editFrameworks') | translate }}
      </div>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="flex flex-col gap-5">
      @for (framework of frameworks$ | async; track framework.id) {
        <app-framework-summary-edit [frameworkId]="framework.id"></app-framework-summary-edit>
      }
    </div>
  </ng-template>
</app-base-side-panel-modal>
